"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loginRequest = exports.msalConfig = void 0;
exports.msalConfig = {
    auth: {
        clientId: process.env.VUE_APP_MSAL_CLIENT_ID || '',
        authority: 'https://login.microsoftonline.com/organizations',
        redirectUri: window.location.origin
    },
    cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: false
    }
};
exports.loginRequest = {
    //scopes: ['User.Read']
    scopes: ["api://".concat(process.env.VUE_APP_MSAL_CLIENT_ID, "/access_as_user")]
};
